// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table{border-collapse:collapse;border-radius:4px;border-style:hidden;box-shadow:0 0 0 1px #e8ebf1}table thead th{border-bottom:1px solid #e8ebf1 !important}table td{border-top:1px solid #e8ebf1 !important}.table-striped tbody tr:nth-of-type(odd){background-color:#fafafa !important}table td:nth-of-type(odd),table th:nth-of-type(odd){border-right:1px solid #e8ebf1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
